import React from 'react';
import Container from 'react-bootstrap/Container';

function BigImageSection() {
  return (
    <div className="site-section">
      <Container>
        <img src="/images/img_10.jpg" width="100%" alt="Woman smiling next to yellow flowers" />
      </Container>
    </div>
  );
}

export default BigImageSection;
